import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Authorization from 'containers/Authorization';
import {
  getCompanyId,
  getCompanySettingsUrl,
  getCorporateUrl,
} from 'store/modules/company';
import { findId as findFacilityId } from 'store/modules/facilities';
import styles from './HelpLink.scss';

const HelpLink = ({
  urlFn,
  text,
  authorization,
  ...props
}) => {
  if (props.hyperUrl) props.fmsUrl = props.hyperUrl.slice(0, props.hyperUrl.indexOf('hyper'));

  return (
    <Authorization {...authorization}>
      {authorized => (
        <div className={styles.message}>
          This information is pulled in from your facility management software.
          To edit contact support{authorized && (
            <React.Fragment>
              &nbsp;or go to&nbsp;
              <a href={urlFn(props)} target="_blank" rel="noopener noreferrer">
                {text}
              </a>
            </React.Fragment>
          )}.
        </div>
      )}
    </Authorization>
  );
};

HelpLink.propTypes = {
  urlFn: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  hyperUrl: PropTypes.string,
  authorization: PropTypes.shape({
    action: PropTypes.string,
    subject: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.array,
    ]),
  }),
};

HelpLink.defaultProps = {};

const mapStateToProps = (state, props) => ({
  facilityId: findFacilityId(props, state),
  companyId: getCompanyId(state),
  corporateUrl: getCorporateUrl(state),
  hyperUrl: getCompanySettingsUrl(state),
});

const ConnectedHelpLink = connect(mapStateToProps)(HelpLink);

export const createHelpLink = ({ urlFn, text, authorization }) => ({
  label: <ConnectedHelpLink urlFn={urlFn} text={text} authorization={authorization} />,
});

export default HelpLink;
